export enum SMBCapitalCustomQuestionKeys {
  BIRTH_YEAR = 'birthYear',
  BORN_IN_US = 'bornInUS',
  BUSINESS_HOURS = 'businessHours',
  OTHER_EMPLOYMENT = 'otherEmployment',
  ACADEMIC_STATUS = 'academicStatus',
  SECTOR = 'sector',
  EDUCATION_LEVEL = 'educationLevel',
  STUDENT_DEBT = 'studentDebt',
  PANDEMIC_DEBT_PAYMENTS = 'pandemicDebtPayments',
  CRIMINAL_HISTORY_OR_FELONY = 'criminalHistoryOrFelony',
  DEPENDENTS = 'dependents',
  ISSUES_WITH_AFFORDABLE_CHILDCARE = 'issuesWithAffordableChildcare',
  TRANSPORTATION = 'transportation',
  HAS_BANK_ACCOUNT = 'hasBankAccount',
  OWNS_ASSETS = 'ownsAssets',
  CREDIT_SCORE_ASSISTANCE = 'creditScore.assistance',
  BUSINESS_REASON = 'businessReason',
  NAME_OF_BUSINESS = 'nameOfBusiness',
  DOING_BUSINESS_AS = 'doingBusinessAs',
  LEGAL_STRUCTURE = 'legalStructure',
  OPERATING_AGREEMENT = 'operatingAgreement',
  INSURED = 'insured',
  INDUSTRY = 'industry',
  SOCIAL_IMPACT_VENTURE = 'socialImpactVenture',
  BRANDING_MATERIALS = 'brandingMaterials',
  BRANDING_MATERIALS_INTERESTED_IN = 'brandingMaterialsInterestedIn',
  SOCIAL_MEDIA = 'socialMedia',
  RESOURCES_NEEDED = 'resourcesNeeded',
  REVENUE_FROM_ONLINE_SALES = 'revenueFromOnlineSales',
  ONLINE_AD_BUDGET = 'onlineAdBudget',
  REVENUE_FROM_POP_UPS = 'revenueFromPopUps',
  AVERAGE_ANNUAL_REVENUE_RANGE = 'averageAnnualRevenueRange',
  OPERATING_IN_KCMO = 'operatingInKCMO',
  INTERACTED_WITH_CITY_DEPARTMENTS = 'interactedWithCityDepartments',
  EXPERIENCE_OBTAINING_A_BUSINESS_LICENSE = 'experienceObtainingABusinessLicense',
  HAS_BUSINESS_ACCOUNT = 'hasBusinessAccount',
  HAS_RELATIONSHIP_WITH_A_BANKER = 'hasRelationshipWithABanker',
  USES_AN_ACCOUNTANT = 'usesAnAccountant',
  HAS_BUSINESS_CREDIT_CARD = 'hasBusinessCreditCard',
  HAS_APPLIED_FOR_BUSINESS_LOANS = 'hasAppliedForBusinessLoans',
  CHALLENGES_FACED_ACCESSING_CAPITAL = 'challengesFacedAccessingCapital',
  COVID_RELIEF_PROGRAMS = 'covidReliefPrograms',
  RAISING_CAPITAL = 'rasingCapital',
  POS_SYSTEM = 'POSSystem',
  BUSINESS_ADDRESS = 'businessAddress',
  LOCATION_CATEGORY = 'locationCategory',
  SQUARE_FOOTAGE = 'squareFootage',
  STARTED_AT_HOME = 'startedAtHome',
  PLAN_TO_MOVE_TO_LARGER_SPACE = 'planToMoveToLargerSpace',
  PAY_YOURSELF_AS_W2 = 'payYourselfAsW9',
  HAS_EMPLOYEES = 'hasEmployees',
  NUMBER_OF_FULLTIME_EMPLOYEES = 'numberOfFulltimeEmployees',
  OFFERS_BENEFITS_FULLTIME = 'offersBenefitsFulltime',
  FULL_TIME_BENEFITS = 'fullTimeBenefits',
  NUMBER_OF_PARTTIME_EMPLOYEES = 'numberOfParttimeEmployees',
  OFFERS_BENEFITS_PARTTIME = 'offersBenefitsParttime',
  PART_TIME_BENEFITS = 'partTimeBenefits',
  PLAN_TO_HIRE = 'planToHire',
  PLANNED_FULLTIME_ROLES = 'plannedFulltimeRoles',
  PLANNED_PARTTIME_ROLES = 'plannedParttimeRoles',
  SELL_TO_GOV_OR_CORP = 'sellToGovOrCorp',
  CERTIFICATIONS = 'certifications',
  HAS_GOV_CONTRACT = 'hasGovContract',
  PART_OF_CORP_DIVERSITY_PROGRAM = 'partOfCorpDiversityProgram',
  HAS_CORP_CONTRACT = 'hasCorpContract',
  RUNS_BUSINESS_FROM_HOME = 'runsBusinessFromHome',
  HAS_WEBSITE = 'hasWebsite',
  HAS_HOME_INTERNET = 'hasHomeInternet',
  APPLIED_TO_ACP = 'appliedToACP',
  HAS_COMPUTER = 'hasComputer',
  DEVICES = 'devices',
  TECH_INTERESTS = 'techInterests',
  PUBLIC_ASSISTANCE = 'publicAssistance',
  FEEDBACK = 'feedback',
  SOURCE = 'source',
}
